import {doppeActionTypeDefineViewerMetadata} from '../../client-server-common/doppe-action-types/doppe-action-type';
import React from 'react';
import {doppeActionTypeHoppService} from './doppe-action-type-hopp-service';

export const doppeActionTypeHoppServiceViewer = doppeActionTypeDefineViewerMetadata(doppeActionTypeHoppService, {

    loadViewerComponents: async () => {
        return {
            DoppeActionTypeHoppServiceWidget: (await import('./doppe-action-type-hopp-service-widget/doppe-action-type-hopp-service-widget')).DoppeActionTypeHoppServiceWidget
        }
    },

    renderWidget: (renderProps, viewerComponents) => {

        const {
            DoppeActionTypeHoppServiceWidget
        } = viewerComponents;

        return (
            <DoppeActionTypeHoppServiceWidget
                {...renderProps}
            />
        );
    },
});